// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ReconciliationDownloadFromBankController = function (
    $scope,
    $http, 
    $location, 
    ReconciliationImport, 
    ReconciliationImportHistoryService,
    BlEbicsAvailabilityService,
    gettext,
    gettextCatalog, DatepickerUtils) {

    $scope.dateRange = { dateFrom: null, dateTo: null };

    $scope.isDownloadingStarted = false;
    $scope.isRequestSent = false;

    $scope.isInvalidDates = false;
    $scope.invalidDatesSpecificError = '';

    $scope.isFirstOpen = true;
    $scope.paginationIsOn = false;
    $scope.isError = false;

    $scope.isDownloadButtonShown = true;
    $scope.isImportFileButtonShown = true;

    $scope.importLog = [];
    $scope.openedItems = [];

    $scope.requiredToUpdate = true;

    BlEbicsAvailabilityService.requestEbicsAvailableFlag();

    $scope.isEbicsAvailable = function () {
        return BlEbicsAvailabilityService.isEbicsAvailable();
    };

    var getLog = function () {
        ReconciliationImport.query({}, function (data) {
            if(!$scope.openedItems)
                $scope.openedItems = [];

            $scope.importLog = data;
            ReconciliationImportHistoryService.processPreviouslyOpenedElements($scope.importLog, $scope.openedItems);

            if(ReconciliationImportHistoryService.areAllItemsInTerminalPhase(data)) {
                $scope.requiredToUpdate = false;
            }
        });
    };

    getLog();

    var source = Rx.Observable
        .interval(10000)
        .timeInterval();

    var subscription = source.subscribe(
        function (x) {
            if(!$scope.requiredToUpdate){
                return;
            }

            getLog();
        });

    var download = function () {
        $scope.isDownloadButtonShown = false;
        $scope.isImportFileButtonShown = false;
        
        let params = { };
        DatepickerUtils.setSearchParamsWithStringRange(params, $scope.dateRange);

        $http({
            method: "POST",
            url: "/api/v1/reconciliationImport/downloadFromBank",
            params: {},
            data: { "From": params.dateFrom, "To": params.dateTo },
            headers: { "Content-Type": "application/json" },
            cache: false
        }).then(
            function () {
                $scope.isDownloadingStarted = false;
                $scope.isRequestSent = true;
            },
            function (error) {
                $scope.isDownloadingStarted = false;
                $scope.isError = true;
            });
    };

    $scope.sendRequestToBank = function()
    {
        let validateDates = function()
        {   
            if (!$scope.dateRange.dateFrom || !$scope.dateRange.dateTo) {
                $scope.invalidDatesSpecificError =  gettextCatalog.getString(gettext("Both dates must be picked!"));
                return false;
            }

            if ($scope.dateRange.dateFrom > $scope.dateRange.dateTo) {
                $scope.invalidDatesSpecificError =  gettextCatalog.getString(gettext("The start date must be lower than the end date!"));
                return false;
            }

            var endMoment = moment($scope.dateRange.dateTo).startOf('day').add(1, 'days'); // 1 day is required to take into account the last day of a period
            var startMoment = moment($scope.dateRange.dateFrom).startOf('day');

            var dateDifference = endMoment.diff(startMoment, 'days');
            if (dateDifference > 31) {
                $scope.invalidDatesSpecificError = gettextCatalog.getString(gettext("The date range must not be greater than 31 days!"));
                return false;
            }

            return true;
        }

        $scope.isInvalidDates = false;

        if(validateDates()) {
            $scope.requiredToUpdate = true;
            $scope.isDownloadingStarted = true;
            download();
        }
        else {
            $scope.isInvalidDates = true;
        }
    }

    $scope.back = function () {
        if($scope.isRequestSent || $scope.isError) {
            $scope.isRequestSent = false;
            $scope.isError = false;
        }
        else {
            $location.path("/activities/reconciliation");
        } 
    };

    $scope.navigateToImportFromFile = function () {
        $location.path("/activities/reconciliationImport");
    };

    $scope.navigateToDownloadFromBank = function () {
        $scope.dateRange.dateFrom = null;
        $scope.dateRange.dateTo = null;
        $scope.isDownloadingStarted = false;
        $scope.isRequestSent = false;
        $scope.isError = false;
    };

    $scope.ReconciliationImportMode = ReconciliationImportHistoryService.RECONCILIATION_IMPORT_MODE;

    $scope.toggleImportInfoVisibility = function(importItem, index) {
        ReconciliationImportHistoryService.toggleOpenedItem($scope.openedItems,importItem.Id);

        if(index == 0 &&  $scope.isFirstOpen) {
            $scope.isFirstOpen = false;
        }
        else {
			ReconciliationImportHistoryService.toggleImportInfoVisibility(importItem);
		}
    };

    $scope.setHistoryItemHeader = function(importItem)
    {
        return ReconciliationImportHistoryService.setHistoryItemHeader(importItem);
    }

    $scope.IsListEmpty = function(list)
    {
        return ReconciliationImportHistoryService.IsListEmpty(list);
    }

    $scope.getProcessingStatusClass = function(statusValue)
    {
       return ReconciliationImportHistoryService.getProcessingStatusClass(statusValue);
    }

    $scope.$on("$destroy", function handler() {
        subscription.dispose();
    });
   

    $scope.getStatusFileColumnMessage = function(item) {
        return ReconciliationImportHistoryService.getStatusFileColumnMessage(item);
    }

    $scope.showSpecificError = function(errorMessage) {

        ReconciliationImportHistoryService.showSpecificError(errorMessage);
    };
};
ReconciliationDownloadFromBankController.$inject = ['$scope','$http','$location', 'ReconciliationImport',
    'ReconciliationImportHistoryService', 'BlEbicsAvailabilityService', 'gettext', 'gettextCatalog', 'DatepickerUtils'];
